import script from "./MenuBarTextColor.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBarTextColor.vue?vue&type=script&setup=true&lang=js"

import "./MenuBarTextColor.vue?vue&type=style&index=0&id=0f40e7cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f40e7cc"]])

export default __exports__